import { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useMsal } from "@azure/msal-react";
import AlliantgroupLogo from '../../../assets/Icons/AlliantgroupLogo.svg';
import TickCircle from '../../../assets/Icons/TickCircle.svg';
import { useAppDispatch } from '../../../store/hooks';
import { startLoading, stopLoading } from '../../../slices/loading.slice';
import './Signout.scss'
import { signOut } from '../../../services/apis';


const Signout = () => {
  const dispatch = useAppDispatch();
  const { instance, accounts } = useMsal();

  useEffect(() => {
    dispatch(startLoading());
    signOut().finally(() => {
      dispatch(stopLoading());
    })
  }, [accounts, instance]);

  return (
    <>
      {accounts.length !== 0 ? (
        <div className='loader-overlay'>
          <CircularProgress />
        </div>
      ) : (
        <div className="signoutContainer">

          <div className="signoutLogoContainer">
            <img src={AlliantgroupLogo} alt={"Logo"} />
          </div>

          <div className="tickCircleContainer">
            <div className="tickCircle"></div>
            <img src={TickCircle} alt={"Icon"} />
            <div className="tickCircle"></div>
          </div>

          <h1>You have been Logged Out</h1>
          <p>Thank You</p>
        </div>
      )}
    </>
  );
};

export default Signout;